import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["bar"]

  connect() {
    const pct = this.barTarget.dataset.widthPct || 0
    this.barTarget.style.setProperty("width", `${pct}%`)
  }
}
